export default __webpack_public_path__ + "static/media/logo.7fb9393f.png";